import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';
import {
  ListAllMasterDatasetsResponse,
  DeleteMasterDatasetRequest,
  DeleteMasterDatasetResponse,
} from '../../../types/masterAdmin';

/**
 * 運営事務向け: 全企業のマスタデータセット一覧を取得する（#3254）
 * Cloud SQL を主に、Firestore の状態を突き合わせた結果が返る
 */
export const listAllMasterDatasets = async (): Promise<ListAllMasterDatasetsResponse> => {
  const fn = httpsCallable<void, ListAllMasterDatasetsResponse>(
    functions,
    'listAllMasterDatasetsApi',
  );
  const result = await fn();
  return result.data;
};

/**
 * 運営事務向け: マスタデータセットを Cloud SQL から物理削除する（#3254）
 * Firestore で論理削除済み、または Firestore に存在しない孤児のみ削除できる
 */
export const deleteMasterDatasetPhysically = async (
  params: DeleteMasterDatasetRequest,
): Promise<DeleteMasterDatasetResponse> => {
  const fn = httpsCallable<DeleteMasterDatasetRequest, DeleteMasterDatasetResponse>(
    functions,
    'deleteMasterDatasetPhysicallyApi',
  );
  const result = await fn(params);
  return result.data;
};
